
import Injection = EECore.Injection;

@Injection.injectableClass("DocumentCentreFavouriteDocumentListBehavior")
export default class FavouriteDocumentBehavior {

  @Injection.injectableProperty("DocumentCentreFavouriteDocumentListBehavior", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  constructor(htmlHelper: EECore.HtmlHelper) {
    this.htmlHelper = htmlHelper;
  }

  apply(documentListElement: Element): void {
    const showAllButton = documentListElement.querySelector("[data-action='show-all']");
    showAllButton.addEventListener("click", () => {
      this.htmlHelper.removeCssClass(showAllButton, "visible");
      this.htmlHelper.addCssClass(showAllButton, "hidden");
      const hiddenDocuments = documentListElement.querySelectorAll(".ee_favourite_document.hidden");
      for (let i = 0; i < hiddenDocuments.length; i++) {
        this.htmlHelper.removeCssClass(hiddenDocuments[i], "hidden");
        this.htmlHelper.addCssClass(hiddenDocuments[i], "visible");
      }
    });
  }

}